import script from "./ModalImagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalImagePreview.vue?vue&type=script&setup=true&lang=js"

import "./ModalImagePreview.vue?vue&type=style&index=0&id=25fca4aa&lang=scss"

const __exports__ = script;

export default __exports__